import { render, staticRenderFns } from "./Kunst.vue?vue&type=template&id=43455d77&"
import script from "./Kunst.vue?vue&type=script&lang=js&"
export * from "./Kunst.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports